
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {}
})
export default class extends Vue {
  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
